const bulanQuiz = [ 
    {
    question: "Bulan adalah satelit dari planet apa?",
    options: ["Mars", "Bumi", "Jupiter", "Venus"],
    answer: 1,
  },
  {
    question: "Mengapa Bulan terlihat bercahaya di malam hari?",
    options: [
      "Karena memancarkan cahaya sendiri",
      "Karena pantulan cahaya Matahari",
      "Karena ada api di permukaannya",
      "Karena efek atmosfer",
    ],
    answer: 1,
  },
  {
    question: "Berapa lama waktu yang dibutuhkan Bulan untuk mengelilingi Bumi?",
    options: ["7 hari", "14 hari", "27 hari", "365 hari"],
    answer: 2,
  },
  {
    question: "Permukaan Bulan sebagian besar terdiri dari?",
    options: [
      "Air dan es",
      "Pasir dan tanah",
      "Batu dan debu",
      "Lava cair",
    ],
    answer: 2,
  },
  {
    question: "Fase Bulan ketika Bulan terlihat bulat penuh disebut?",
    options: [
      "Bulan Baru",
      "Bulan Sabit",
      "Bulan Purnama",
      "Bulan Separuh",
    ],
    answer: 2,
  },
  {
    question: "Apakah Bulan memiliki atmosfer tebal seperti Bumi?",
    options: [
      "Ya, sangat tebal",
      "Ya, tipis",
      "Tidak, hampir tidak ada",
      "Sama seperti Mars",
    ],
    answer: 2,
  },
  {
    question: "Siapa manusia pertama yang menginjakkan kaki di Bulan?",
    options: [
      "Yuri Gagarin",
      "Neil Armstrong",
      "Buzz Aldrin",
      "Elon Musk",
    ],
    answer: 1,
  },
  {
    question: "Misi pertama manusia ke Bulan bernama?",
    options: [
      "Apollo 11",
      "Voyager 1",
      "Sputnik",
      "Challenger",
    ],
    answer: 0,
  },
  {
    question: "Gaya apa yang menyebabkan pasang surut air laut di Bumi?",
    options: [
      "Gaya angin",
      "Gaya magnet",
      "Gaya gravitasi Bulan",
      "Gaya panas Matahari",
    ],
    answer: 2,
  },
  {
    question: "Suhu di Bulan bagaimana?",
    options: [
      "Selalu panas",
      "Selalu dingin",
      "Bisa sangat panas dan sangat dingin",
      "Sama seperti Bumi",
    ],
    answer: 2,
  },
];

export default bulanQuiz;